import Text from "components/lib/text";
import { Typography } from "components/typography";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Button } from "@mindlercare/ui-web";
import { BottomContainer, ButtonWrapper, Signature } from "./styled";

const ReferralFooter = ({ t, user, onSubmit, onCancel, submitDisabled }) => {
  return (
    <BottomContainer>
      <ButtonWrapper>
        <Button onClick={onCancel} variant="secondary">
          {t("CANCEL")}
        </Button>
        <Button
          onClick={onSubmit}
          disabled={submitDisabled}
          variant="primary"
          ml={10}
        >
          {t("SEND")}
        </Button>
      </ButtonWrapper>
      <div data-testid="signedByPsychologistName">
        <Typography variant="body-x-small" color="GRAY_DARK">{`${t(
          "SIGNED_BY",
        )}`}</Typography>

        <Text
          as={Signature}
          value={`${user.firstName} ${user.lastName}`}
          sensitiveField={true}
        />
      </div>
    </BottomContainer>
  );
};

ReferralFooter.propTypes = {
  t: PropTypes.func,
  user: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  submitDisabled: PropTypes.bool,
};

export default withTranslation()(ReferralFooter);
